import axios from "axios";
import axiosWithCredential from "app/utils/http/http";
import env from "app/utils/env";
import { getStore } from "app/configureStore";
import { getCredentials } from "app/utils/auth";
import { MY_BOOKINGS_TYPES } from "../constants/myBookingsTypes";

const JSON_HEADERS = { "Content-type": "application/json" };

// Normalise l'échec HTTP comme le faisait le promiseMiddleware : on rejette avec
// `error.response` (qui porte le status HTTP), pour que la gestion d'erreur des
// containers (`response.status`) reste identique après la migration.
const rejectWithResponse = error => Promise.reject(error.response || error);

const getBookingsUrl = () => `${env("ACCOUNT_API_URL")}/getBookings`;

export const fetchBookings = (body = {}) =>
	axiosWithCredential
		.post(getBookingsUrl(), body, { headers: JSON_HEADERS })
		.then(response => response.data, rejectWithResponse);

export const fetchUpcomingBookings = () => fetchBookings({ type: MY_BOOKINGS_TYPES.UPCOMING });

export const fetchPastBookings = () => fetchBookings({ type: MY_BOOKINGS_TYPES.PAST });

export const fetchBookingByReference = bookingReference => fetchBookings({ bookingReference });

// Le paiement d'un due booking : token d'auth ajouté manuellement (paiement depuis le
// compte) ; sans token (site institutionnel) on garde brand/shop dans le payload.
// On résout toujours (jamais de reject) avec la réponse ou `error.response`, comme le
// promiseMiddleware, car le container branche sur `response.status`/`response.data`.
export const postDuePayment = paymentPayload => {
	const shop = getStore()?.getState()?.shop;
	const credentials = getCredentials(shop);
	const token = credentials?.token;
	const url = `${env("ACCOUNT_API_URL")}/addPayment`;
	const headers = { "Content-type": "application/json" };
	const payload = { ...paymentPayload };

	if (token) {
		headers.Authorization = token;
		delete payload.brand;
		delete payload.shop;
	}

	return axios.post(url, payload, { headers }).then(
		response => response,
		error => error.response || error
	);
};

export const fetchCustomerRequestsCount = ({ email, shop, brand }) =>
	axiosWithCredential
		.get(`${env("ACCOUNT_API_URL")}/getCustomerRequests/count`, {
			headers: JSON_HEADERS,
			params: { brandCode: brand, shopCode: shop, email },
		})
		.then(response => response.data);
